"use strict";

class StorageUtil {
  setSessionStorage(key, value) {
    sessionStorage.setItem(key, value);
  }
  getSessionStorage(key) {
    return sessionStorage.getItem(key);
  }
  removeSessionStorage(key) {
    return sessionStorage.removeItem(key);
  }
  setLocalStorage(key, value) {
    return localStorage.setItem(key, value);
  }
  getLocalStorage(key) {
    return localStorage.getItem(key);
  }
  removeLocalStorage(key) {
    return localStorage.removeItem(key);
  }
  setSessionStorageWithExpireTime(key, value, millisecond) {
    const obj = { value, expire: Date.now() + millisecond };
    const objString = JSON.stringify(obj);

    return this.setLocalStorage(key, objString);
  }
  getSessionStorageWithExpireTime(key) {
    const objString = this.getLocalStorage(key);

    if (typeof objString === "undefined" || objString === "undefined" || !objString) {
      return null;
    }

    const obj = JSON.parse(objString);
    if (Date.now() > obj.expire) {
      this.removeLocalStorage(key);
      return null;
    }

    return obj.value;
  }
}

const storageUtil = new StorageUtil();
export default storageUtil;
